import React, { useEffect, useState } from "react";
import { HomeWrapper } from "../../../components/business/CdBalance/style";
import { Ptag } from "../../../components/fonts";
import { Root } from "../ViewCd/styles";
import http from "../../../services/httpService";
import BufferCard from "./BufferCard";

function ViewCB() {
  const [loader, setLoader] = useState(false);
  const [bufferData, setBufferData] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userplan_id = localStorage.getItem("cb_flag");
        const { data } = await http.post(
          "/business/get_corporate_buffer_data/",
          { userplan_id: userplan_id }
        );
        // localStorage.setItem('')
        setBufferData(data);
      } catch (e) {
        console.log(e);
      } finally {
        setLoader(false);
      }
    };
    setLoader(true);
    fetchData();
  }, []);
  return (
    <Root style={{ padding: "4rem" }}>
      <Ptag fontSize="24px" fontWeight="700" marginBottom="36px">
        Corporate Buffer
      </Ptag>
      {<BufferCard details={bufferData} />}
    </Root>
  );
}

export default ViewCB;
